import {useId, useState} from 'react';

/**
 * Custom hook for managing accordion state.
 * This hook initializes the accordion being closed and provides functions to toggle its state.
 *
 * @returns An object containing the guaranteed unique IDs for header and content elements, the current state of the accordion, and a function to toggle the state.
 *
 * @example
 * ```ts
 * const { contentId, headerId, isOpen, toggleIsOpen } = useAccordion();
 * ```
 */
export const useAccordion = () => {
    const [isOpen, setIsOpen] = useState(false);
    const id = useId();

    const headerId = `${id}-header`;
    const contentId = `${id}-content`;

    /**
     * Toggles the state of the accordion between open and closed.
     * This function flips the current state of the accordion from open to closed or vice versa.
     */
    const toggleIsOpen = () => {
        setIsOpen(!isOpen);
    };

    return {
        contentId,
        headerId,
        isOpen,
        toggleIsOpen
    };
};